import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5013';

/**
 * Oturumsuz parola uçları (şifremi unuttum, parola belirle).
 * Kasıtlı olarak `apiClient` kullanılmıyor: onun 401 yakalayıcısı /login'e
 * yönlendiriyor ve her hatada genel bir bildirim basıyor. Bu sayfalar giriş
 * yapılmadan açılır ve kendi hata metinlerini kendileri gösterir.
 */
const publicClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export interface ParolaBelirtecBilgisi {
  email: string;
  amac: 'davet' | 'sifirlama';
}

export const parolaApi = {
  unuttum: async (email: string): Promise<{ message: string }> => {
    const response = await publicClient.post<{ message: string }>('/api/parola/unuttum', { email });
    return response.data;
  },

  belirtecDogrula: async (belirtec: string): Promise<ParolaBelirtecBilgisi> => {
    const response = await publicClient.get<ParolaBelirtecBilgisi>('/api/parola/belirle', {
      params: { t: belirtec },
    });
    return response.data;
  },

  belirle: async (belirtec: string, parola: string): Promise<{ message: string }> => {
    const response = await publicClient.post<{ message: string }>('/api/parola/belirle', {
      belirtec,
      parola,
    });
    return response.data;
  },
};

/** Axios hatasından API'nin `message` alanını okur. */
export function apiMesaji(error: unknown): string | undefined {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: unknown } | undefined;
    if (typeof data?.message === 'string' && data.message) return data.message;
  }
  return undefined;
}

export function hataDurumu(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}
